import {
  HomeView,
  CategoryView,
  NodeView,
  CartView,
  OrdersView,
  ProductView,
  CompleteProfileView,
  AddressListView,
  ViewProfile,
  SearchView,
  AddressFormView,
  ShareView,
  FavoriteView,
  RegisterView,
  OrderView,
  InfoView,
  OrderAddressStepView,
  OrderPaymentTypeStepView,
  OrderFinalizeStepView,
  OrderTimeTableStepView,
  OrderCompleteStepView,
  WelcomeView,
  ForgetPasswordView,
  EditProfileView,
} from 'content/views';

//TODO in ghesmat baraye test gereftan hast
var routes = [
  {
    path: '/',
    keepAlive: true,
    component: HomeView,
    // component: OrderView, options: { props: { id: 2046 } },
    // component: SearchView,
    // component: WelcomeView,
    // component: RegisterView,
    // component: OrderCompleteStepView,
    // component: ViewProfile,
    // component: AddressStep,
    // options: {
    //   props: {

    //   }
    // },
    // component: PaymentTypeStep,
    // component: ShareView,
    // component: InfoView,
    // component: ForgetPasswordView,
    // component: EditProfileView,
    // component: CompleteProfileView,
    // component: CategoryView,
    // component: AddressListView,
    // component: CartView,
    // component: NodeView,
    // options: {
    //   props: {
    //     id: 9,
    //   }
    // }
    // component: AddressFormView,
    // options: {
    //   props: {
    //     id: "new",
    //   }
    // }
    // component: ProductView,
    // options: {
    //   props: {
    //     id: 213222,
    //   }
    // }
    // component: OrdersView,
  },
  {
    path: '/addresses',
    component: AddressListView,
  },
  {
    path: '/address/:id',
    component: AddressFormView,
  },
  {
    path: '/cart',
    component: CartView,
    // component: OrderTimeTableStepView

  },
  {
    path: '/category',
    component: CategoryView,
    keepAlive: true,
  },
  {
    path: '/favorite',
    component: FavoriteView,
  },
  {
    path: '/forget_password',
    component: ForgetPasswordView
  },
  {
    path: '/info',
    component: InfoView,
    keepAlive: true,
  },
  {
    path: '/share',
    component: ShareView,
  },
  {
    path: '/node/:id',
    component: NodeView,
  },
  {
    path: '/node/:id/:sort',
    component: NodeView,
  },
  {
    path: '/orders',
    component: OrdersView,
  },
  {
    path: '/order/:id',
    component: OrderView,
  },
  {
    path: '/product/:id',
    component: ProductView,
  },
  {
    path: '/profile',
    component: ViewProfile,
  },
  {
    path: '/profile/complete',
    component: CompleteProfileView,
  },
  {
    path: '/profile/edit',
    component: EditProfileView,
  },
  {
    path: '/register',
    component: RegisterView,
  },
  {
    path: '/search',
    component: SearchView,
  },
  {
    path: '/step/address',
    component: OrderAddressStepView,
    // component: OrderPaymentTypeStepView,
    // component: OrderTimeTableStepView
  },
  {
    path: '/step/payment_type',
    component: OrderPaymentTypeStepView,
  },
  {
    path: '/step/finalize',
    component: OrderFinalizeStepView,
  },
  {
    path: '/step/complete',
    component: OrderCompleteStepView,
    options: {
      reloadAll: true,
    }
  },
  {
    path: '/welcome',
    component: WelcomeView
  },
  // Default route, match to all pages (e.g. 404 page)
  {
    path: '(.*)',
    component: InfoView,
  },
];

export default routes;
